<ng-container *ngTemplateOutlet="plainCover; context: { catalogRecord }"/>
@if (showFavoriteStatus && favoriteService.favorites | async; as favorites) {
  <ng-container *ngTemplateOutlet="favoriteToggle; context: { isFavorite: !!favorites[catalogRecord.id] }"/>
}

<ng-template #plainCover let-cr="catalogRecord">
  <a routerLink="/catalog-item/{{ catalogRecord.id }}">
    <rn-image-container [catalogRecord]="cr" [alt]="cr.title"/>
  </a>
</ng-template>

<ng-template #favoriteToggle let-isFavorite="isFavorite">
  <div class="favorite-control" (click)="$event.stopPropagation()">
    @if (!isFavorite) {
      <mat-icon (click)="addFavorite()" class="favorite-heart">favorite_border</mat-icon>
    }
    @if (isFavorite) {
      <mat-icon (click)="deleteFavorite()" class="favorite-heart">favorite</mat-icon>
    }
  </div>
</ng-template>
